<template>
    <div>
        <h2>{{ step.title }}</h2>
        <p class="step__notice">
            All fields with an asterisk are required
            <i class="fas fa-asterisk"></i>
        </p>
        <p>Please tell us about your health and personal support needs.</p>
        <p>
            <b>
                Please be honest and share as much information as you can - the
                more we understand the better we can help you.
            </b>
        </p>

        <InputRadioGroup
            name="any_illness"
            :required="isRequired('any_illness')"
            :error="form.errors.get('any_illness')"
            v-model="form.any_illness"
            :options="getField('any_illness').options"
            @input="form.errors.clear('any_illness')"
            :onChange="clearIllnessAnswer"
        >
            <template v-slot:question>
                {{ getField("any_illness").question }}
            </template>
            <template v-slot:description>
                <small class="d-block mb-3">
                    Examples of mental health challenges and psychological
                    conditions include anxiety, depression, bipolar, obsessive
                    compulsive disorder, personality disorder, eating disorder,
                    ADHD, self-harm.
                </small>
                <small class="d-block mb-3">
                    Examples of disabilities include needing a wheelchair,
                    having a long-term illness, severe asthma, dyslexia,
                    epilepsy, ME, Asperger’s syndrome, autism.
                </small>
                <small class="d-block mb-3">
                    Not sure how to answer this question?
                    <a
                        href="https://www.citizensadvice.org.uk/work/discrimination-at-work/checking-if-its-discrimination/check-if-youre-disabled-under-the-equality-act"
                        target="_blank"
                    >
                        Check if you’re disabled under the Equality Act
                    </a>
                </small>
            </template>
        </InputRadioGroup>

        <InputCheckboxGroup
            v-if="form.any_illness == 'yes'"
            name="any_illness_reasons"
            :required="isRequired('any_illness_reasons')"
            :error="form.errors.get('any_illness_reasons')"
            v-model="form.any_illness_reasons"
            :options="getField('any_illness_reasons').options"
            :form="form"
            @textarea-updated="form[$event.field] = $event.value"
        >   
            <template v-slot:question>
                {{ getField("any_illness_reasons").question }}
            </template>
        </InputCheckboxGroup>

        <InputRadioGroup
            name="alcohol_drug_dependent"
            :required="isRequired('alcohol_drug_dependent')"
            :error="form.errors.get('alcohol_drug_dependent')"
            v-model="form.alcohol_drug_dependent"
            :options="getField('alcohol_drug_dependent').options"
            @input="form.errors.clear('alcohol_drug_dependent')"
        >
            <template v-slot:question>
                {{ getField("alcohol_drug_dependent").question }}
            </template>
            <template v-slot:description>
                {{ getField("alcohol_drug_dependent").description }}
            </template>
        </InputRadioGroup>
    </div>
</template>

<script>
import InputRadioGroup from "../Form/InputRadioGroup";
import InputCheckboxGroup from "../Form/InputCheckboxGroup";
import Form from "../../Form";
import { isRequired } from "./formHelper.js";

export default {
    name: "StepHealth",
    components: {
        InputRadioGroup,
        InputCheckboxGroup,
    },
    methods: {
        getField(fieldName) {
            return this.fields[fieldName];
        },
        isRequired(fieldName) {
            var fieldData = this.getField(fieldName);
            return isRequired(fieldData, this.form);
        },
        clearIllnessAnswer(value) {
            if (value === 'no') this.form.any_illness_reasons = [];
        }
    },
    data: function () {
        return {
            form: new Form({
                any_illness: null,
                any_illness_reasons: null,
                illness_reason_disability_text: null,
                illness_reason_illness_text: null,
                illness_reason_mental_health_psychological_text: null,
                illness_reason_other_text: null,
                alcohol_drug_dependent: null,
            }, this.formData),
        };
    },
    props: {
        step: Object,
        fields: Object,
        formData: Object,
    },
};
</script>